// must be first
import './polyfills'

import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { TrackingEventType } from '@ftr/foundation'
import { WindowConfig, WindowRef } from '@ftr/window'
import { AppModule } from '~app/app.module'
import { environment } from '~environments/environment'

if (environment.production) {
  enableProdMode()
}

/**
 * If we are in a production environment, we need to bootstrap angular config variables are loaded.
 * process.env.CONFIG is set in the webpack config.
 * This script contains things like our logging url etc.
 */

const ref = window as unknown as WindowRef
ref.config = process.env.CONFIG as unknown as WindowConfig

enableTracking()
enableNewRelicMonitoring()
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err))

/**
 * Google tag manager tracking script, just done in body, rather than head, due to needing the config
 */
function enableTracking(): void {
  const windowRef = window as unknown as WindowRef
  if (!windowRef.dataLayer) {
    windowRef.dataLayer = [{ 'gtm.start': new Date().getTime(), event: 'gtm.js' as TrackingEventType }]
    const script = document.createElement('script')
    script.async = true
    const config = windowRef.config || environment.config
    const origin = `${windowRef.location.protocol}//${windowRef.location.host}`
    const gtmWebAppContainerCode = config?.TrackingContainerCode || 'GTM-WFSPRKK'
    const gtmCourtsAppContainerCode = config?.CourtsTrackingContainerCode || 'GTM-NL6DDR7R'
    const isCourtsPortal = origin === config?.CourtsAppUrl
    const gtmContainerCode = isCourtsPortal ? gtmCourtsAppContainerCode : gtmWebAppContainerCode
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmContainerCode}`
    document.body.appendChild(script)
  }
}

function enableNewRelicMonitoring(): void {
  const windowRef = window as unknown as WindowRef
  if (windowRef.config?.NewRelicWebAppId) {
    const newrelicScript = document.createElement('script')
    newrelicScript.src = '/newrelic.js'
    document.head.appendChild(newrelicScript)
  }
}
